/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
export {
  SDK_INFO,
  _globalThis,
  otperformance,
  getBooleanFromEnv,
  getStringFromEnv,
  getNumberFromEnv,
  getStringListFromEnv,
} from './node';
